import { productCodeMap } from '@/utils/document/product-code-map';

const path = '/img/products/MPS';
const docConfig = { name: '产品文档', link: productCodeMap.MPS };
export const BANNER_DATA = {
  title: '媒体处理',
  backgroundImg: `${path}/banner.webp`,
  description:
    '媒体处理（MPS，Media Process Service）针对海量多媒体内容提供高质量、高效率、低成本的处理服务，如音视频转码、视频修复与增强、智能生产、音频处理等。通过丰富的原子能力与场景化的解决方案帮助客户提升多媒体处理环节的质量与效率',
  buttonText: '申请试用',
  buttonLink: '',
  // mobileExtraButton: { ...docConfig},
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  links: [
    // { name: 'Demo体验', link: '' },
    // { ...docConfig },
    // { name: '管理控制台', link: '' },
  ],
};
export const ADVANTAGES_EFFECT = [
  {
    title: '丰富的处理能力',
    content:
      '基于亿级DAU产品实践经验，真实的业务场景中提炼出“视频分析与编码”、“视频修复增强”、“智能生产”等丰富的媒体处理能力族，满足客户不同场景使用需求',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '领先的编解码技术',
    content:
      '业界领先的转码产品“质臻轻流”及”质臻影音“，基于内容感知与分析，结合AI手段对视频进行自适应修复增强，突破编码压缩极限，在保持相同主观画质的情况下，以更低的码率实现更优的画质',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '高效稳定的服务',
    content:
      '大规模实战业务场景支撑，按需动态扩缩容、灵活应对高并发；实时报警监控，保证服务稳定性；海量训练数据支撑能力迭代，持续降低处理成本、实现高效转码',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '点播全流程解决方案',
    content:
      '既可灵活使用单点媒体处理能力，又可串联媒资上传、管理、分发、播放等环节，满足视频点播全流程需求，高效匹配多样化业务场景',
    picUrl: `${path}/icon4.webp`,
  },
];

export const FEATURES = [
  {
    title: '视频分析与编码',
    content:
      '覆盖主流格式、高效、可定制的媒体转码服务。支持质臻轻流、条件转码、分片转码、视频加密等，结合视频基础特征分析与画质监测，转码后视频主观质量更好，转出码率更低',
    picUrl: `${path}/3d-icon1.webp`,
  },
  {
    title: '视频修复与增强',
    content:
      '兼顾码率要求，基于视频修复&增强能力的弹性组合，对视频噪点、模糊、色偏等失真进行针对性修复，并可通过超分辨率、插帧、SDR转HDR、音频增强等手段提升视频音画质量，打造极致视听盛宴',
    picUrl: `${path}/3d-icon2.webp`,
  },
  {
    title: '智能生产',
    content:
      '通过智能封面、智能抠图、精彩剪辑等AI生产能力提升生产创作环节的自动化、智能化水平，优化生产效率、拓展创意空间',
    picUrl: `${path}/3d-icon3.webp`,
  },
  {
    title: '音频处理',
    content:
      '先进的的音频处理能力，满足音频增强、降噪、回声消除等音频场景需求，并支持节拍跟踪、百变音效、虚拟演唱会、线上KTV等丰富的音频玩法',
    picUrl: `${path}/3d-icon4.webp`,
  },
];

export const SCENARIO_EFFECT = [
  {
    title: '视频场景',
    content:
      '覆盖短/中/长视频平台，通过集视频存储、转码、分发、播放、数据驱动的体验优化等于一体的点播解决方案，为客户提供更全面、高效、稳定的服务',
    picUrl: `${path}/scenario1.webp`,
  },
  {
    title: '在线教育',
    content:
      '通过提供高清低码的视频转码服务，降低存储及分发带宽成本，适配不同终端平台的播放。支持视频加密，为您的视频版权保驾护航',
    picUrl: `${path}/scenario2.webp`,
  },
  {
    title: '广电传媒',
    content:
      '修复经典老片的画质问题，并可通过超分辨率、插帧、SDR转HDR、音频增强等手段打造更沉浸的视听体验，焕发影片生机',
    picUrl: `${path}/scenario3.webp`,
  },
  {
    title: '视频制作',
    content:
      '通过智能生产能力提升视频制作效率，提升视觉效果，包括智能抠图、一键成片、智能裁剪等，快速制作满足不同消费场景的作品',
    picUrl: `${path}/scenario4.webp`,
  },
];

export const ARCHITECTURE = {
  title: '产品架构',
  picUrl: `${path}/architecture.webp`,
};

export const BRAND = {
  title: '客户案例',
  items: ['拉拉公园', '多多视频', '知乎', '小米'],
};
